import { useTransitionState } from '@pocketlaw/tetris';
import { AnimatedContainer } from './styled';
export function Digit(props) {
    const { active, children } = props;
    const state = useTransitionState(active, 100);
    return <AnimatedContainer $state={state}>{children}</AnimatedContainer>;
}
